export const SCOPE = "modules/user/onboarding/";

export const GET_WIZARD = SCOPE + "GET_WIZARD";
export const UPDATE_WIZARD = SCOPE + "UPDATE_WIZARD";
export const CLAIM_DISCOUNT = SCOPE + "CLAIM_DISCOUNT";
export const INSIDER_ONBOARDING = SCOPE + "INSIDER_ONBOARDING";



// WEBPACK FOOTER //
// ./src/modules/user/onboarding/types.js